import { RejectionReason } from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimRejectionReason'
import React from 'react'

export const rejectionReasonContent = {
    WRITER_DOCUMENTATION_NEEDED: (
        <>
            <p>
                Your claim requires additional documentation. The documentation you provided shows your rights transfer
                from a publisher or administrator but not the songwriter’s transfer of rights to the publisher or
                administrator.
            </p>
            <p>
                To maintain your claim, please submit documentation showing the songwriter’s transfer of rights. If you
                have any questions, please reach out to our team at overclaims@themlc.com.
            </p>
        </>
    ),
    CLAIMANT_DOCUMENTATION_NEEDED: (
        <>
            <p>
                To maintain your claim, please submit documentation showing your agreement with the publisher or
                administrator from whom you have acquired rights to the work. If you have any questions, please reach
                out to our team at overclaims@themlc.com.
            </p>
        </>
    ),
    INCOMPLETE_DOCUMENTATION: (
        <>
            <p>
                Your claim requires additional documentation. The documentation you provided is missing key terms or
                information that was either redacted or not included.
            </p>
            <p>
                To maintain your claim, please provide substantiating documentation that includes this missing
                information. If you have any questions, please reach out to our team at overclaims@themlc.com.
            </p>
        </>
    ),
    MISSING_DOCUMENTATION: (
        <>
            <p>
                Your claim requires additional documentation. The documentation you provided does not substantiate your
                claim on behalf of each songwriter whose shares were claimed.
            </p>
            <p>
                Please provide substantiating documentation for each of the songwriters subject to your claim. If you
                have any questions, please reach out to our team at overclaims@themlc.com.
            </p>
        </>
    ),
    FOREIGN_LANGUAGE_DOCUMENTATION: (
        <>
            <p>
                Your claim requires additional documentation. We require all claimants who submit documents in a
                language other than English to also submit a completed Foreign Language Substantiating Documentation
                Summary.
            </p>
            <p>
                You can access and download the form{' '}
                <a href="https://www.themlc.com/policies#:~:text=of%20the%20policies.-,FOREIGN%20LANGUAGE%20DOCUMENTATION,-When%20The%20MLC">
                    here
                </a>
                . Once completed, please submit the form along with your supporting documentation for further review.
            </p>
        </>
    ),
    DOCUMENT_DOES_NOT_FOLLOW_GUIDELINES: (
        <>
            <p>
                Your claim requires additional documentation. The documentation you provided does not meet the
                guidelines listed in Section 5.1 of The MLC Dispute Policy.
            </p>
            <p>If you have any questions, please reach out to our team at overclaims@themlc.com.</p>
        </>
    ),
    DOCUMENTATION_NOT_RELEVANT_TO_WORK: (
        <>
            <p>
                Your claim requires additional documentation. The documentation you submitted does not establish a claim
                to the work subject to this overclaim.
            </p>
            <p>If you have any questions, please reach out to our team at overclaims@themlc.com.</p>
        </>
    ),
    WRITER_NOT_REGISTERED_ON_WORK: (
        <>
            <p>
                The documentation you submitted is for a writer who isn't currently registered on the work. Please
                provide documentation that shows this writer's relationship to a claim on the work.
            </p>
            <p>If you have any questions, please reach out to our team at overclaims@themlc.com.</p>
        </>
    ),
    UNABLE_TO_VIEW: (
        <>
            <p>
                We were unable to open the documentation you submitted. Please resubmit it through the Overclaims Tool.
            </p>
        </>
    ),
    STATUTORY_TERMINATION: (
        <>
            <p>
                Your claim is the result of a statutory termination and cannot be processed via the Overclaims Tool.
                <a href="https://www.themlc.com/statutory-terminations">Click here</a> to submit the Termination Notice
                Form.
            </p>
            <p>If you have any questions, please reach out to our team at overclaims@themlc.com.</p>
        </>
    ),
    SKIPPED: <></>,
} satisfies Record<RejectionReason, React.ReactNode>
